import { useQuery } from '@tanstack/react-query';
import qs from 'qs';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { QueryConfig } from '@/src/lib/react-query/react-query';

import { LibraryItemDTO } from '../types';

const url = `${PREFIX_URL}/library/download`;

export type downloadFileResponse = {
  status: boolean;
  data: LibraryItemDTO[];
};

export type downloadFileDTO = {
  folderIds: number[];
};

export const downloadFileQueryKey = {
  list: ['downloadFile'] as const,
};
export const getDownloadFileUrl = (folderIds: number[]) => {
  const query = folderIds.map((id) => `ids[]=${id}`).join('&');
  return `${url}?${query}`;
};

export const downloadFile = ({ folderIds }: downloadFileDTO): Promise<downloadFileResponse> => {
  const URL = getDownloadFileUrl(folderIds);

  return axios.get(URL);
};
type QueryFnType = typeof downloadFile;

type UsedownloadFileOptions = {
  folderIds: number[];
  config?: QueryConfig<QueryFnType>;
};

export const useDownloadFile = ({ folderIds, config }: UsedownloadFileOptions) => {
  return useQuery({
    queryKey: [...downloadFileQueryKey.list, folderIds],
    queryFn: () => downloadFile({ folderIds }),
    cacheTime: 0,
    staleTime: Infinity,
    ...config,
  });
};
